import type { AccountRow } from '../../../api/accounts'

function EmailIcon({ email }: { email: string }) {
	return (
		<span className="sign-in-icon" title={email}>
			<svg viewBox="0 0 24 24" role="img" aria-label={`Email: ${email}`}>
				<rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
				<path d="m4 7 8 6 8-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
			</svg>
		</span>
	)
}

function AppleIcon() {
	return (
		<span className="sign-in-icon" title="Sign in with Apple">
			<svg viewBox="0 0 24 24" role="img" aria-label="Sign in with Apple">
				<path
					fill="currentColor"
					d="M16.37 12.62c-.02-2.3 1.88-3.4 1.96-3.46-1.07-1.56-2.73-1.78-3.32-1.8-1.41-.14-2.76.83-3.48.83-.72 0-1.83-.81-3-.79-1.55.02-2.97.9-3.77 2.28-1.6 2.78-.41 6.9 1.15 9.16.76 1.1 1.67 2.34 2.87 2.3 1.15-.05 1.59-.75 2.98-.75 1.39 0 1.78.75 3 .72 1.24-.02 2.02-1.12 2.78-2.23.87-1.28 1.23-2.52 1.25-2.58-.03-.01-2.4-.92-2.42-3.66zM14.1 5.86c.64-.77 1.07-1.85.95-2.92-.92.04-2.03.61-2.69 1.38-.59.68-1.1 1.77-.97 2.82 1.03.08 2.07-.52 2.71-1.28z"
				/>
			</svg>
		</span>
	)
}

/** How an account signs in, at a glance: an envelope for an email and password, the Apple logo for Sign in with Apple. */
export function SignInIcons({ account }: { account: Pick<AccountRow, 'email' | 'signInKinds'> }) {
	const apple = account.signInKinds.includes('apple')
	if (!account.email && !apple) return <span className="muted">—</span>
	return (
		<span className="sign-in-icons">
			{account.email && <EmailIcon email={account.email} />}
			{apple && <AppleIcon />}
		</span>
	)
}
